export const TOS_ASSET_NAME = 'terms-of-service';
export const PRIVACY_POLICY_ASSET_NAME = 'privacy-policy';

// The signup modal's Terms/Privacy content comes from the in-repo JSON
// (see TermsOfServicePage.js / PrivacyPolicyPage.js) — the Console CMS
// copies are ignored, so there is nothing to fetch. Keeping a resolved
// loadData preserves the SSR contract.
export const loadData = (params, search) => dispatch => {
  return Promise.resolve();
};
